import { IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Input,
  Divider,
  Button,
  Form,
  useTable
} from '@pankod/refine-antd'


import { IGradeLevel } from 'interfaces'
import { CreateGradeLevel } from './create'
import { EditGradeLevel } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const GradeLevelList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)

  const {  sorter, tableQueryResult,setFilters ,tableProps,searchFormProps} = useTable<IGradeLevel>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at', { grades: ['id'] }],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const { tableQueryResult:exportData } = useTable<IGradeLevel>({
    hasPagination:false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at', { grades: ['id'] }],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'grade_levels',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'grade_levels',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'created_at'],
    },
  })

  const hideDeleteButton = (record: IGradeLevel): boolean => {
    const { grades } = record
    if (grades !== undefined) {
      return grades.length > 0
    }
    return false
  }

  // const { triggerExport, isLoading } = useExport<IGradeLevel>()
  

  const triggerExport=()=>{
    exportToExcel(exportData?.data?.data,`GradeLevels_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
          <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps} >
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IGradeLevel>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateGradeLevel modalProps={modalProps} formProps={formProps} />
      <EditGradeLevel modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
